
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13.937 17.039l-2.306-6.997a6.33 6.33 0 01-.034-3.847l1.115-3.592a.63.63 0 00-.215-.699L11.127.865a.614.614 0 00-.97.349l-.392 1.91H5.442L4.535.97a.614.614 0 00-.921-.22L2.092 1.903a.63.63 0 00-.216.699L2.99 6.195a6.33 6.33 0 01-.034 3.847l-2.306 7a.621.621 0 00.267.734 12.584 12.584 0 006.377 1.598 12.587 12.587 0 006.375-1.602.622.622 0 00.267-.733z"}}),_c('path',{attrs:{"d":"M3.153 9.31c1.337.444 2.734.677 4.142.69a13.494 13.494 0 004.141-.69m-5.995 5.064l-.835 4.74m4.541-4.74l.835 4.74"}})])])
          )
        }
      }
    